import createReactClass from 'create-react-class';
('use strict');

// Import Libraries
import React from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames';
// Import JS Modules
import GenericPaginatedUploadMixin from './loader-mixins/generic-paginated-upload-mixin';
import UploadAnalytics from './upload-analytics';
import { builderDispatch, PrismUI, WebUI } from '../_utils/ui';
import FileClearingMixin from './loader-mixins/file-clearing-mixin';
import FileSelectorMixin from './loader-mixins/file-selector-mixin';
import UploadButton from './utils/upload-button';
import AlbumSelector from './album-selector';
import CustomText from './custom-text';
import ImageUploadFileValidator from '../_utils/image-upload-file-validator';
import AnalyticsHandler from '../_libs/analytics/checkout-google-analytics';
import sendToGoogleAnalytics from '../_libs/analytics/builder-send-to-google-analytics';
import { db, handleDexieError } from '../_utils/db/db';
import { uploadUrl } from '../_prism-builder/desktop/lib/add-photos-interface';
import { compressImage } from '../_utils/db/image-manip-helpers';
import { convertHEICIfNeeded } from '../_prism-builder/components';
import { usePrismItemStore } from 'stores/usePrismItemStore';
import * as pdfjsLib from 'pdfjs-dist';
import readFileAsArrayBuffer from '../_utils/readFileAsArrayBuffer';
import { sessionTracker } from '../_prism-builder/utils/session-tracker';
import { ACCEPTED_FORMATS_NOTE } from './accepted-formats-note';

const LocalFileImportIndexedDB = createReactClass({
  mixins: [GenericPaginatedUploadMixin, FileSelectorMixin, FileClearingMixin],
  displayName: 'Local file import native',

  getInitialState() {
    const { App } = window;
    this.files = this.files || [];

    return {
      loggedIn: App && App.order.logged_in(),
    };
  },
  componentDidMount() {
    this.builderDispatchToken = builderDispatch.register((payload) => {
      if (payload.type === WebUI.LOGIN) {
        this.setState({
          loggedIn: true,
        });
      }
    });
    const component = ReactDOM.findDOMNode(this);
    component.addEventListener('dragover', this.handleDragOver, false);
    component.addEventListener('dragenter', this.handleDragEnter, false);
    component.addEventListener('dragleave', this.handleDragLeave, false);
    component.addEventListener('drop', this.handleDrop, false);
    if (this.props.setFunctions) {
      this.props.setFunctions([
        this.pause,
        this.clear,
        this.restart,
        this.removeFile,
        this.performUpload,
        this.performBeamrUpload,
        this.clearUploaded,
        this.sendAnalytics,
        this.filesSelected,
        this.totalNumberOfFilesSelected,
        this.restoreFiles,
      ]);
    }
  },
  componentWillUnmount() {
    const component = ReactDOM.findDOMNode(this);
    component.removeEventListener('dragover', this.handleDragOver, false);
    component.removeEventListener('dragenter', this.handleDragEnter, false);
    component.removeEventListener('dragleave', this.handleDragLeave, false);
    component.removeEventListener('drop', this.handleDrop, false);
  },
  sendAnalytics(eventCategory) {
    const eventLabel = UploadAnalytics.eventTypes(
      this.files.map((f) => f.uploadAnalytics),
    );

    const payload = {
      type: WebUI.Analytics.SEND,
      eventCategory: eventCategory,
      eventAction: 'device',
      eventLabel: eventLabel,
      eventValue: this.files.length,
    };

    AnalyticsHandler.handleAnalyticsEvent(payload);
  },

  render() {
    return (
      <div
        id={'image-loader-service-' + this.props.service}
        style={{ height: this.props.height }}
        className={classNames(
          'text-center image-loader-service',
          this.props.service,
          { 'd-none': !this.props.isActive },
        )}
        tabIndex="0">
        <div className="d-flex d-lg-none h-100 flex-column justify-content-center">
          <i className="d-none d-lg-block large fas fa-laptop" />
          <i className="mx-auto d-lg-none large fas fa-mobile-alt" />
          <h3 className="title service-title font-weight-bold">My Phone</h3>
          <small>Upload photos from your phone.</small>
          <div className="mobile-file-upload-btn">
            <UploadButton
              label="Upload"
              ariaLabel="Upload"
              onChange={this.handleFileInputChange}
              fileValidator={this.props.fileValidator}
            />
          </div>
          <CustomText
            textKey="imageLoaderLocalFileImportBannerHtml"
            className="local-file-import-banner local-file-import-banner-mweb d-none"
          />
        </div>
        <div id="fileList" />
        <div
          id="dropArea"
          data-test-id="dropArea" // For testing purposes
          style={{ height: this.props.height }}
          className={classNames(
            'd-md-none d-lg-flex my-auto justify-content-center',
            { 'd-none': this.props.isMobile },
          )}>
          <div className="album-selector-box d-none">
            <div className="image-loader-form-elements">
              {!!this.state.loggedIn && (
                <AlbumSelector
                  targetAlbum={this.props.targetAlbum}
                  onAlbumSelected={this.handleTargetAlbumSelected}
                />
              )}
            </div>
          </div>
          <div
            className={classNames('device', { 'd-none': this.props.isMobile })}>
            <i className="large fas fa-cloud-upload-alt" />
            <h3 className="title font-weight-bold">Drag &amp; Drop Here</h3>
            <small className="d-block">
              {ACCEPTED_FORMATS_NOTE}
            </small>
            <UploadButton
              label="Upload Photos"
              ariaLabel="Upload"
              onChange={this.handleFileInputChange}
              fileValidator={this.props.fileValidator}
            />
          </div>
        </div>
      </div>
    );
  },

  handleTargetAlbumSelected(album) {
    if (this.props.onTargetAlbumSelected)
      this.props.onTargetAlbumSelected(album);
  },

  draggable() {
    return (
      'draggable' in document.createElement('span') && !this.props.isMobile
    );
  },

  handleDragOver(e) {
    e.stopPropagation();
    e.preventDefault();
  },

  dragCounter: 0,
  handleDragEnter(e) {
    e.preventDefault();

    if (this.dragCounter++ === 0) $('#dropArea').addClass('dragover');
  },

  handleDragLeave(e) {
    if (--this.dragCounter === 0) $('#dropArea').removeClass('dragover');
  },

  handleDrop(e) {
    e.preventDefault();

    this.dragCounter = 0;
    $('#dropArea').removeClass('dragover');

    const files = Array.prototype.slice.apply(e.dataTransfer.files);
    this.addFiles(files);
    return false;
  },

  triggerFeatureTracking() {
    sendToGoogleAnalytics('offline-local-import', '');
  },

  handleFileInputChange(e) {
    this.triggerFeatureTracking();
    const $fileInput = e.target;
    const files = Array.from($fileInput.files);

    if (!files.length) return;

    this.addFiles(files);
    $fileInput.value = '';
  },

  async addFiles(files) {
    const filteredFiles = files.filter(
      this.props.fileValidator.isAcceptedFileType,
    );

    if (filteredFiles.length > 0) {
      builderDispatch.dispatch({
        type: WebUI.UPLOAD_BEGUN,
        number_of_files: filteredFiles.length,
      });

      usePrismItemStore.setState(({ imagesUploadProgress }) => ({
        imagesUploadProgress: {
          current: 1,
          totalFiles: filteredFiles.length,
        },
      }));

      builderDispatch.dispatch({
        type: PrismUI.CLOSE_ADD_PHOTOS_MODAL,
      });

      for (let uncompressedImageFile of filteredFiles) {
        try {
          if (uncompressedImageFile.type === 'application/pdf') {
            await processPDF(uncompressedImageFile);
          } else {
            await processImage(uncompressedImageFile);
          }
        } catch (error) {
          dispatchAndDisplayFailedUpload(uncompressedImageFile.name);
          console.error('Error processing file:', error);
        }
      }
    }
  },
  _buildFormData() {
    return false;
  },
});

LocalFileImportIndexedDB.defaultProps = {
  fileValidator: new ImageUploadFileValidator(),
};

const processFileAndUpload = async (uncompressedImageFile, processedFile) => {
  const compressedImageForThumbnails = await compressImage(
    processedFile || uncompressedImageFile,
    { maxWidthOrHeight: 512 },
  );

  const fileToUpload = processedFile || uncompressedImageFile;

  // Uploaded as-is (only the thumbnail is compressed). A PDF page arrives with
  // the whole PDF as its original, so only image files report a picked size.
  sessionTracker.trackUploadedImage({
    sentBytes: fileToUpload.size,
    pickedBytes:
      uncompressedImageFile.type === 'application/pdf'
        ? undefined
        : uncompressedImageFile.size,
  });

  const fileData = {
    file: fileToUpload,
    compressedImage: compressedImageForThumbnails,
    status: 'pending',
    uploadUrl: uploadUrl(),
    prismItemID: prismItem.num,
    prismItemIDs: [],
    createdAt: new Date(),
  };

  db.imageUpload
    .add(fileData)
    .then(() => console.log(`${fileData.file?.name} uploaded successfully`))
    .catch((e) => {
      return handleDexieError(e, { from: 'processFileAndUpload' });
    });
  return fileData;
};


const processPDF = async (uncompressedImageFile) => {
  const pdfData = await readFileAsArrayBuffer(uncompressedImageFile);

  try {
    pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdn.jsdelivr.net/npm/pdfjs-dist@${pdfjsLib.version}/build/pdf.worker.min.mjs`;

    const pdfDoc = await pdfjsLib.getDocument({ data: pdfData }).promise;
    const numPages = pdfDoc.numPages;

    builderDispatch.dispatch({
      type: WebUI.UPLOAD_BEGUN,
      number_of_files: numPages,
    });

    usePrismItemStore.setState(({ imagesUploadProgress }) => ({
      imagesUploadProgress: {
        current: 1,
        totalFiles: numPages,
      },
    }));

    sendToGoogleAnalytics('pdf-upload', numPages);

    const canvasPDF = document.createElement('canvas');
    canvasPDF.style.display = 'none';
    document.body.appendChild(canvasPDF);
    const ctx = canvasPDF.getContext('2d');

    for (let pageNum = 1; pageNum <= numPages; pageNum++) {
      const page = await pdfDoc.getPage(pageNum);
      const viewport = page.getViewport({ scale: 2 });

      canvasPDF.width = viewport.width;
      canvasPDF.height = viewport.height;

      await page.render({
        canvasContext: ctx,
        viewport: viewport,
        background: 'rgba(0,0,0,0)',
      }).promise;

      const blob = await new Promise((resolve) =>
        canvasPDF.toBlob(resolve, 'image/png'),
      );
      const fileName = `${uncompressedImageFile.name}-${pageNum}.png`;
      const newFile = new File([blob], fileName, { type: 'image/png' });

      await processFileAndUpload(uncompressedImageFile, newFile);
    }
    document.body.removeChild(canvasPDF);
  } catch (error) {
    dispatchAndDisplayFailedUpload(uncompressedImageFile.name);
    console.error('Error processing PDF:', error);
  }
};

const dispatchAndDisplayFailedUpload = (fileName) => {
  builderDispatch.dispatch({
    type: WebUI.UPLOAD_PROGRESS,
  });

  usePrismItemStore.getState().trackProgress();

  usePrismItemStore.setState(({ failedImagesUploaded }) => ({
    failedImagesUploaded: [...failedImagesUploaded, fileName],
  }));
};

const processImage = async (uncompressedImageFile) => {
  const convertedFile = await convertHEICIfNeeded(uncompressedImageFile);
  await processFileAndUpload(uncompressedImageFile, convertedFile);
};

export default LocalFileImportIndexedDB;
